// dell-1996 design tokens carrying the shubhamgl.com biome palette.
//
// Shape and type come from design-md/dell-1996: zero radius, hard 1px borders,
// no soft shadows, Arial Black display + Helvetica body. Colors are sampled from
// the portfolio-objective screenshots — each section is its own "biome", with a
// single orange (#ff8236) as the only chromatic accent across all of them.
//
// The old Apple key names are kept as aliases at the bottom so components that
// have not been migrated yet still compile. Removed in the final phase.

// Per-section surfaces. `bg` is the full-bleed field, `card` the window body.
export const biome = {
  hero: {
    bg: "#080e1c",
    ink: "#ffffff",
    card: "#101828",
    muted: "#6b7280",
    accent: "#ff8236",
  },
  about: {
    bg: "#1e1911",
    ink: "#f0ece4",
    card: "#1e1c1a",
    muted: "#9a938a",
    accent: "#ff8236",
  },
  experience: {
    bg: "#bda07c",
    ink: "#3a2a1a",
    card: "#f8eee1",
    muted: "#6c5b47",
    accent: "#8a5a2a",
  },
  projects: {
    bg: "#1b0e0e",
    ink: "#f0e6e6",
    card: "#140b0b",
    muted: "#9a8383",
    accent: "#ff8236",
  },
  connect: {
    bg: "#f0f7e4",
    ink: "#1a3a0a",
    card: "#ffffff",
    muted: "#5a6b4a",
    accent: "#e07a2a",
  },
  footer: {
    bg: "#0d1b0a",
    ink: "#8a9a80",
    card: "#1c2919",
    muted: "#5a6b50",
    accent: "#ff8236",
  },
};

export const theme = {
  biome,

  // ---- Accent (the only chromatic color in the system) ----
  orange: "#ff8236",
  orangeDeep: "#c85f1e",
  onOrange: "#ffffff",

  // ---- The literal page frame (dell-1996's strongest single device) ----
  frameInk: "#000000",
  frameWidth: "8px",
  frameWidthSm: "4px",

  // ---- Lines. Hard hairlines only; they replace every shadow. ----
  hairlineOnDark: "rgba(255, 255, 255, 0.16)",
  hairlineOnLight: "rgba(0, 0, 0, 0.28)",

  // ---- Radius. Square is the universal default. ----
  radius: {
    none: "0px",
    full: "9999px", // achievement medallions / award seals ONLY
  },

  // ---- Elevation. Hard offset, zero blur. Never a soft shadow. ----
  bevel: "3px 3px 0",
  bevelSm: "2px 2px 0",

  // ---- Layout ----
  maxWidth: "1200px",
  maxWidthNarrow: "980px",
  section: "96px",

  // ---- Type. OS defaults, no webfont — dell-1996 needed no fallback. ----
  fonts: {
    display: "'Arial Black', 'Arial Bold', Gadget, Helvetica, sans-serif",
    body: "Helvetica, Arial, sans-serif",
    ui: "Helvetica, Arial, sans-serif",
  },

  type: {
    heroName: "clamp(48px, 9vw, 112px)",
    sectionTitle: "clamp(34px, 5vw, 56px)",
    cardTitle: "24px",
    subTitle: "16px",
    body: "15px",
    bodySm: "13px",
    uiLabel: "12px",
  },

  // ---- Spacing (dell-1996's 4px base with 2/6/10 intermediates) ----
  space: {
    xxs: "2px",
    xs: "4px",
    s: "6px",
    sm: "8px",
    m: "10px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    xxl: "24px",
    sectionSm: "32px",
    section: "40px",
    sectionLg: "48px",
  },
};

export default theme;
